import script from "./DestinationGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./DestinationGuide.vue?vue&type=script&lang=ts&setup=true"

import "./DestinationGuide.vue?vue&type=style&index=0&id=f1903b58&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f1903b58"]])

export default __exports__